import gql from 'graphql-tag'

export const getVideo = gql`
  query DooerComGetVideo($id: ID!) {
    academy {
      video(id: $id) {
        id
        title
        description {
          plain
          source
        }
        videoSource {
          ... on YoutubeVideo {
            id
          }
          ... on WistiaVideo {
            url
          }
        }
        durationInSeconds
        relatedPlatforms
        relatedURL
      }
    }
  }
`
